// Corresponds with bitfield in SQL - Person.Platforms
export enum Platform {
  None = 0,
  Web = 1,
  Apple = 2,
  Android = 4
}
